/*
 *  Author: DL
 *  Date: 2020-12-03 18:04:01
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-08 15:00:51
 *  LastEditors: DL
 *  Description: 输入框组件
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { Icon } from 'ui';
import styles from './index.less';

export default forwardRef(function(props, ref) {
    const { prefix, suffix, ...inputProps } = props;

    const fixClassName = classnames({
        [`${prefix}`]: !!prefix,
        [`${suffix}`]: !!suffix,
        [`${styles.icon}`]: true,
    });

    const inputClassName = classnames({
        [`${styles.input}`]: true,
    });

    return (
        <div className={styles.wrapper}>
            {prefix ? <Icon className={fixClassName} /> : null}
            <input ref={ref} className={inputClassName} {...inputProps} />
            {suffix ? <Icon className={fixClassName} /> : null}
        </div>
    );
});
